import React, {Component} from 'react';
import API from "../../services/API";
import Toast from "../Common/Toast";
import Actionbar from "../Common/Actionbar";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faAngleLeft,
    faTruck
} from "@fortawesome/free-solid-svg-icons";
import Navbar from "../Common/Navbar";
import Loading from "../Common/Loading";

class OwnersList extends Component {
    state = {
        owners : [],
        request: [],
        present_today : 0,
        present_tomorrow : 0,
        isLoaded: false,
        driverName: ''
    }
    onSearchDriver = (event) => {
        this.setState({driverName : event.target.value})
        if(event.target.value.length > 2) {
            const request = {
                search_key : event.target.value
            }
            API.getOwners(request)
                .then((response) => {
                    this.setState({owners : response.results.owners , request : response.results.request})

                })
                .catch((error) => {
                    //   toast.error(error.response.data.user_message);
                });
        }
        if(event.target.value.length  < 1) {
            const request = {
                expert_owners : true,

            }
            API.getOwners(request)
                .then((response) => {
                    this.setState({owners : response.results.owners , request : response.results.request})

                })
                .catch((error) => {
                    //   toast.error(error.response.data.user_message);
                });
        }

    }

    render() {
        return (
            <React.Fragment>
                {!this.state.isLoaded ? <Loading/> :''}
                <Toast/>
                <Actionbar noBack={0} title='لیست مالکین خودروها'/>
                <section className="container p-4 rtl my-5">
                    <div className="row my-3">
                        <div className="col-12">
                            <div className="form-floating super-small-2">
                                <input type="text" className="form-control height-40" id="floatingInput"
                                       placeholder="جستجو  راننده"
                                       onChange={this.onSearchDriver}
                                       value={this.state.driverName}
                                />
                                <label htmlFor="floatingInput">جستجو مالک با نام خانوادگی</label>
                            </div>

                        </div>


                    </div>
                    {
                        this.state.owners.map(driver => {

                            return (
                                <div className='row driver-row' key={driver.id}
                                     onClick={() => {this.props.history.push('/owners/' + driver.id) }}
                                >
                                    <div className="col-2">
                                        <img src={driver.avatar} alt="avatar" className='w-100 rounded-more'/>
                                    </div>
                                    <div className="col-8">
                                        {driver.full_name}
                                        {driver.work_today ?
                                            <div className='badge badge-info badge-pill bg-warning  mx-2'>
                                                اعلام حضور
                                            </div> : ''
                                        }
                                        <div className='super-small-2 mt-2'>
                                            <FontAwesomeIcon icon={faTruck}/>
                                            &nbsp;
                                            {driver.car_type}
                                        </div>
                                    </div>
                                    <div className='col-2 pt-2 text-left'>

                                            <FontAwesomeIcon icon={faAngleLeft} className='text-success '/>

                                    </div>

                                </div>

                            )

                        })
                    }
                </section>
                <Navbar  />
            </React.Fragment>
        );
    }
    componentDidMount() {
        const request = {

        }
        API.getOwners(request)
            .then((response) => {
                this.setState({owners : response.results.owners , request : response.results.request})
                this.setState({ isLoaded : true})
                setTimeout (() => {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                },400)

            })
            .catch((error) => {
                //   toast.error(error.response.data.user_message);
            });
    }
}

export default OwnersList;